import { IClientConfigs, RgbColor } from '~/shared';
import { createSlice } from '../wrappers';

interface ColorPickerSlice {
	selectedColor: RgbColor;
	indexedColor: number;
	sectionIndex: number;
	paintGroup: IClientConfigs['vehiclesPaint']['types'][number] | null;
	pearlColor: number;
	rimsColor: number;
}

const initialState: ColorPickerSlice = {
	selectedColor: { r: 255, g: 255, b: 255 },
	indexedColor: 0,
	sectionIndex: 0,
	paintGroup: null,
	pearlColor: 0,
	rimsColor: 0,
};

const colorPickerSlice = createSlice({
	name: 'colorPicker',
	initialState,
	reducers: {
		setSelectedColor: (state, action) => {
			state.selectedColor = action.payload;
		},
		setSectionIndex: (state, action) => {
			state.sectionIndex = action.payload;
		},
		setPearlColor: (state, action) => {
			state.pearlColor = action.payload;
		},
		setRimsColor: (state, action) => {
			state.rimsColor = action.payload;
		},
		setGroup: (state, action) => {
			state.paintGroup = action.payload;
		},
		setIndexedColor: (state, action) => {
			state.indexedColor = action.payload;
		},
	},
});

export const {
	setSelectedColor,
	setSectionIndex,
	setPearlColor,
	setGroup,
	setIndexedColor,
	setRimsColor,
} = colorPickerSlice.actions;

export default colorPickerSlice.reducer;
